document.addEventListener('DOMContentLoaded', function () {
    // Disable the first option of a select field when the class .disable-first-option is present
    const selectFields = document.querySelectorAll('.disable-first-option select');
    selectFields.forEach(selectField => {
        selectField.options[0].disabled = true; // Disable the first option
    });

    // START CODE FOR VALID WCAG ERROR MESSAGES

    // Apply unique IDs to form labels and corresponding form controls (like input fields)
    document.querySelectorAll('.wpcf7').forEach(function(wpcf7Div) {
        let wpcf7Id = wpcf7Div.getAttribute('id'); // Get the form's unique ID

        wpcf7Div.querySelectorAll('label.visually-hidden, label.custom-file-upload').forEach(function(label, index) {
            let forAttr = label.getAttribute('for') || 'label-'; // Get the label's 'for' attribute or create a default one
            
            // Create a new unique 'for' attribute based on form ID and index
            let newForAttr = `${forAttr}-${wpcf7Id}-${index}`;
            label.setAttribute('for', newForAttr); // Set the new 'for' attribute

            // Find the corresponding input element inside the same div as the label
            let input = label.closest('div').querySelector('.wpcf7-form-control');
            if (input) {
                input.setAttribute('id', newForAttr); // Assign the input field a matching unique ID
            }
        });
    });

    // Functie om foutmeldingen bij te werken voor ongeldige velden in het formulier
    function updateErrorMessages(formUnique) {
        // Zoek het formulier op basis van het unieke formulier-ID
        const targetNode = document.querySelector('#' + formUnique);
        if (!targetNode) return;  // Stop als het formulier nog niet in de DOM staat

        // Zoek alle ongeldige velden in het formulier
        const invalidFields = targetNode.querySelectorAll('.wpcf7-not-valid-tip'); // Alle ongeldige velden selecteren

        if (invalidFields.length > 0) {
            invalidFields.forEach(field => {
                const previousSibling = field.previousElementSibling; // Het veld vóór het foutbericht
                if (!previousSibling) return;  // Sla over als er geen vorige sibling is

                const fieldId = previousSibling.getAttribute('id'); // ID van het ongeldige veld
                const label = document.querySelector(`label[for="${fieldId}"]`); // Het label dat bij het veld hoort
                const fieldName = label ? label.textContent.trim() : 'veld'; // Naam van het veld uit het label
                const fieldAriaDescribedby = previousSibling.getAttribute('aria-describedby'); // aria-describedby controleren
                const ariaDescribedby = fieldAriaDescribedby ? document.querySelector(`#${fieldAriaDescribedby} a`) : null;

                const lang = document.querySelector('.check-current-lang-en') ? 'en' : 'nl'; // Bepaal de taal (en of nl)

                // Verkrijg de huidige tekst van de foutmelding
                let errorMessage = field.textContent.trim();

                // Pas de foutmelding alleen aan als fieldName nog niet is ingesteld
                if (!errorMessage.includes(fieldName)) {
                    // Vervang "Het veld" door "Het veld [veldnaam]" in de foutmelding, afhankelijk van de taal
                    if (lang === 'nl') {
                        errorMessage = errorMessage.replace("Het veld", `Het veld ${fieldName}`);
                    } else if (lang === 'en') {
                        errorMessage = errorMessage.replace("The field", `The ${fieldName} field`);
                    }
                }

                // Werk de foutmelding bij
                field.textContent = errorMessage;

                // Werk de aria-describedby tekst bij, indien van toepassing
                if (ariaDescribedby) {
                    ariaDescribedby.textContent = errorMessage;
                }
            });
        }
    }

    // Luister naar de 'blur' gebeurtenis van velden met de klasse .wpcf7-form-control
    document.addEventListener('blur', function(event) {
        // Controleer of het uitgelaten element een .wpcf7-form-control is
        if (event.target && event.target.classList.contains('wpcf7-form-control')) {
            const form = event.target.closest('.wpcf7'); // Zoek het dichtstbijzijnde .wpcf7 formulier
            if (form) {
                const formUnique = form.getAttribute('id');
                updateErrorMessages(formUnique); // Werk de foutmeldingen bij wanneer de focus het veld verlaat
            }
        }
    }, true);

    // Zorg ervoor dat de foutmeldingen worden bijgewerkt na het verzenden van het formulier
    document.addEventListener('wpcf7invalid', function(event) {
        const form = event.target.closest('.wpcf7'); // Zoek het dichtstbijzijnde .wpcf7 formulier
        if (form) {
            const formUnique = form.getAttribute('id');
            setTimeout(() => {
                updateErrorMessages(formUnique); // Werk de foutmeldingen bij na een formulierverzending

                const responseOutput = form.querySelector('.wpcf7-response-output');
                if (responseOutput && (responseOutput.textContent.includes('Eén of meer velden bevatten een fout') || responseOutput.textContent.includes('One or more fields contain an error'))) {
                    const screenReaderResponse = form.querySelector('.screen-reader-response ul');
                    const responseOutputP = form.querySelector('.screen-reader-response p[aria-live]');
                    
                    if (screenReaderResponse && responseOutputP) {
                        // Verzamel de tekst van de a links
                        const links = screenReaderResponse.querySelectorAll('a');
                        let linkTexts = '';
                        
                        links.forEach(link => {
                            linkTexts += `<li>${link.textContent}</li>`; // Voeg elke tekst van een link toe als een lijstitem
                        });
                        
                        // Voeg de tekst van de a links toe na de foutmelding in de responseOutput
                        responseOutput.innerHTML = responseOutput.textContent + '<br>' + '<ul>' + linkTexts + '</ul>';
                        
                        // Voeg de tekst van de a links toe na de foutmelding in de responseOutputP
                        responseOutputP.innerHTML = responseOutputP.textContent + '<br>' + '<ul>' + linkTexts + '</ul>';
                    }
                }
            }, 0); // Zorg ervoor dat de foutmeldingen pas na de verzending worden bijgewerkt
        }
    }, true);

    // END CODE FOR VALID WCAG ERROR MESSAGES
});
